import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Modal from '../Modal';
import {Content, FormDescription, Header} from '../LoginForm/styles';
import clearSession from '../../actions/clear-session';
import {hideModal} from '../../reducers/modalReducer';


class KioskOrderCompleteModal extends Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.clearSession();
    }, 1000 * 10);
  }

  render() {
    const {hideModal: hideModalProp} = this.props;

    return (
      <Modal overlayTop={0} isOpened onClose={hideModalProp}>
        <Content compact>
          <Header>
            <span>ORDER COMPLETE</span>
          </Header>
          <FormDescription>
            We will call you when your order is ready to pickup.
          </FormDescription>
        </Content>
      </Modal>
    );
  }
}

KioskOrderCompleteModal.propTypes = {
  clearSession: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  clearSession: () => dispatch(clearSession()),
  hideModal: () => dispatch(hideModal())
});

export default connect(null, mapDispatchToProps)(KioskOrderCompleteModal);



// WEBPACK FOOTER //
// ./src/components/KioskOrderCompleteModal/KioskOrderCompleteModal.jsx